import React from "react";
import { useNavigate } from "react-router-dom";
import { FolderPlus } from "lucide-react";

export default function NoProject({ title = "No project selected" }) {
  const navigate = useNavigate();
  return (
    <div className="p-8 fade-up">
      <div className="studio-card p-16 flex flex-col items-center text-center">
        <div className="w-16 h-16 rounded-2xl bg-[#212534] flex items-center justify-center mb-4">
          <FolderPlus size={30} className="text-[#E6B04E]" />
        </div>
        <h2 className="font-head text-2xl font-bold mb-1">{title}</h2>
        <p className="text-[#94A3B8] text-sm mb-5 max-w-md">Open or create a project first.</p>
        <button className="btn btn-gold" onClick={() => navigate("/projects")}>Go to Projects</button>
      </div>
    </div>
  );
}
